import { SelectableLink, SelectableLinkContainer } from 'components/Link';
import { TextStyle } from 'components/Text';
import Title from 'components/Title';
import { doorCloses } from 'core/constants/sound';
import { getRandomItem } from 'core/utils/logic';
import { processText } from 'core/utils/string';
import { useEscapeGoesBack } from 'hooks/navigation';
import React from 'react';
import styled from 'styled-components';
import { desktop } from 'submodules/sharedText/flavor';
import { usePlaySoundEffect } from 'hooks/sound';

const { general, credit } = desktop;
const flavor = { ...general, ...credit };

const Wrapper = styled.div`
  // display: grid;
  text-align: center;
  margin: 2.5vw;
`;

const Text = styled(TextStyle)`
  margin-top: 1vw;
  font-size: 4vw;
`;

const Credit = () => {
  const playSoundEffect = usePlaySoundEffect();
  const escapeGoesBack = useEscapeGoesBack();

  return (
    <Wrapper>
      <Title white>{processText(flavor.title)}</Title>
      <SelectableLinkContainer handleKeyDown={escapeGoesBack}>
        <SelectableLink
          to="/desktop"
          onClick={() => playSoundEffect(getRandomItem(doorCloses))}
          backButton
        />
      </SelectableLinkContainer>
      <Text white>Created by - Brian Keegan</Text>
      <Text white>Art and Design - Rianna Keegan</Text>
      <Text white>Game concept - Brian Keegan and Hayley Robertson</Text>
      <Text white>Music - Eve Robertson</Text>
      <Text white>Writing - Hayley Robertson and Brian Keegan</Text>
      <Text white>Software Engineer - Brian Keegan</Text>
      <Text white>Font - Dame Hex</Text>
      <Text white>
        Special thanks - Amber Whizin, the Murdoch Family, Kavita Venkataramani
        and so many more!
      </Text>
    </Wrapper>
  );
};

export default Credit;
